document.addEventListener('DOMContentLoaded', () => {

    // Initialize Swiper for Announcement Bar
    const CertificateSwiper = new Swiper('.certificate-icon-text .swiper-certificate', {
      slidesPerView: '1.1',
      spaceBetween: 10,
      loop: false,
      pagination: {
            el: '.certificate-icon-text .swiper-certificate .swiper-pagination',
            clickable: true,
      },
      navigation: {
        nextEl: ".certificate-icon-text .swiper-certificate .swiper-button-next",
        prevEl: ".certificate-icon-text .swiper-certificate .swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 640px
        749: {
          slidesPerView: '2',
          spaceBetween: 20
        },
        1023: {
          slidesPerView: '3',
          spaceBetween: 20
        },
        1250: {
          slidesPerView: '4',
          spaceBetween: 30
        }
      }
    });
    // Initialize Swiper for Announcement Bar
    const CertificateSwiperHomepage = new Swiper('.certificate-icon-text-homepage .swiper-certificate', {
      slidesPerView: '1.1',
      spaceBetween: 10,
      loop: false,
      pagination: {
            el: '.certificate-icon-text-homepage .swiper-certificate .swiper-pagination',
            clickable: true,
      },
      navigation: {
        nextEl: ".certificate-icon-text-homepage .swiper-certificate .swiper-button-next",
        prevEl: ".certificate-icon-text-homepage .swiper-certificate .swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 640px
        749: {
          slidesPerView: '2',
          spaceBetween: 20
        },
        1023: {
          slidesPerView: '4',
          spaceBetween: 20
        }
      }
    });


    // Initialize Swiper for Announcement Bar
    if(window.innerWidth < 749){
      const doctorRecommended = new Swiper('.swiper-doctor_recommended', {
        slidesPerView: '1.1',
        spaceBetween: 10,
        loop: false,
        pagination: {
              el: '.swiper-doctor_recommended .swiper-pagination',
              clickable: true,
        },
      });
      // const latestBuzz = new Swiper('.swiper-latestBuzz', {
      //   slidesPerView: '1.5',
      //   spaceBetween: 10,
      //   loop: false,
      //   pagination: {
      //         el: '.swiper-latestBuzz .swiper-pagination',
      //         clickable: true,
      //   },
      // });
      const graphStrip = new Swiper('.swiper-strip-graph', {
        slidesPerView: '1',
        spaceBetween: 20,
        loop: false,
        pagination: {
              el: '.swiper-strip-graph .swiper-pagination',
              clickable: true,
        },
      });
    }


    // Initialize Swiper for Announcement Bar
    if(window.innerWidth > 767){
      const ingredients = new Swiper('.swiper-ingredients', {
        slidesPerView: '4',
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: ".swiper-ingredients .swiper-button-next",
          prevEl: ".swiper-ingredients .swiper-button-prev",
        },
      });
    }

})